import { InjectionToken, Signal, WritableSignal } from '@angular/core';
import { dsDtos as adminDsDtos, webDtos as adminWebDtos } from '@vectronic/openApi-admin';
import { dsDtos, webDtos } from '@vectronic/openApi-customer';
import {
  DeviceCamerasResponseModel,
  DeviceCommandResponseModel,
  ScheduleResponseModel,
} from '@vectronic/util';
import { Observable } from 'rxjs';
export interface IRemoteCommandProviderService {
  isAdmin: boolean;

  selectedCollars$: Observable<(webDtos.CollarExtended | adminWebDtos.CollarExtended)[]>;
  selectedDropOffs$: Observable<(webDtos.DropOffExtended | adminWebDtos.DropOffExtended)[]>;

  cameraResponse$: Observable<DeviceCamerasResponseModel>;
  remoteParameters$: Observable<
    Array<
      | webDtos.DeviceTypeParameterConfigWithAvailableList
      | adminWebDtos.DeviceTypeParameterConfigWithAvailableList
    >
  >;

  remoteDeviceCommands$: Observable<DeviceCommandResponseModel>;
  remoteSchedules$: Observable<ScheduleResponseModel>;
  availableDeviceFeatures$: Observable<
    dsDtos.DeviceIdWithFeatureList[] | adminDsDtos.DeviceIdWithFeatureList[]
  >;

  deviceTypes$: Observable<(dsDtos.DeviceType | adminDsDtos.DeviceType)[]>;
  parameters$: Observable<(dsDtos.Parameter | adminDsDtos.Parameter)[]>;
  deviceClasses$: Observable<(dsDtos.DeviceClass | adminDsDtos.DeviceClass)[]>;
  parameterSubsystems$: Observable<(dsDtos.Subsystem | adminDsDtos.Subsystem)[]>;
  parameterCategories$: Observable<(dsDtos.ParameterCategory | adminDsDtos.ParameterCategory)[]>;

  isDeviceDataLoading: Signal<boolean>;

  selectedCollarIds: WritableSignal<number[]>;
  isRemote: WritableSignal<boolean>;

  validateRemoteCommand(
    command: webDtos.CustomerNewRemoteCommand | adminWebDtos.CustomerNewRemoteCommand,
  ): Observable<number>;
  getCurrentAnimalNameOfCollarId(collarId: number): string;
}

export const RemoteCommandProviderService = new InjectionToken<IRemoteCommandProviderService>(
  'RemoteCommandProviderService',
);
